import React, { createContext, useState, useEffect } from "react"
import { Cookies } from "react-cookie-consent"

export const ConsentContext = createContext()

export const ConsentProvider = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(false)

  const resetConsent = () => {
    // 1. Remove the standard banner cookie and our functionality flag
    Cookies.remove("CookieConsent")
    Cookies.remove("gatsby-gdpr-functionality")

    // 2. Clear state and refresh to force the banner back and reset embeds
    setHasConsent(false)
    window.location.reload()
  }

  useEffect(() => {
    // Check for the functionality consent cookie
    const functionalityConsent = Cookies.get("gatsby-gdpr-functionality")

    if (functionalityConsent === "true") {
      setHasConsent(true)
    }
  }, [])

  return (
    <ConsentContext.Provider
      value={{ hasConsent, setHasConsent, resetConsent }}
    >
      {children}
    </ConsentContext.Provider>
  )
}